<template>
  <section class="body-content cf">
    <div class="content-wrap">
      <header class="content-header cf" data-testid="form__header">
        <h3 class="action-history-headline">
          {{ $t('actionHistory.title') }}
          <span>{{ $t('orders.createdBy', { userUuid: order.user_uuid }) }}</span>
        </h3>
      </header>
      <div class="content-body">
        <div v-if="parentOrder" class="action-history-content">
          <h4>
            {{ $t('actionHistory.parentOrder.title') }} (<Link :to="`/orders/${parentOrder.uuid}`"
              >{{ $t(labelForOrderType(parentOrderInfo.parentOrderType)) }}: {{ parentOrder.uuid }}</Link
            >)
          </h4>
          <p>
            {{ $t('actionHistory.parentOrder.originZone') }}<span>{{ parentOrderInfo.parentOriginZone }}</span>
          </p>
          <p v-if="parentOrderInfo.parentTargetZone">
            {{ $t('actionHistory.parentOrder.targetZone') }}<span>{{ parentOrderInfo.parentTargetZone }}</span>
          </p>
          <p v-if="parentOrderInfo.parentFullContainer">
            {{ $t('actionHistory.parentOrder.fullContainer') }}<span>{{ parentOrderInfo.parentFullContainer }}</span>
          </p>
          <p v-if="parentOrderInfo.parentEmptyContainer">
            {{ $t('actionHistory.parentOrder.emptyContainer') }}<span>{{ parentOrderInfo.parentEmptyContainer }}</span>
          </p>
        </div>
        <Timeline v-if="actions.length > 0">
          <TimelineItem v-for="action of actions" :key="action.uuid" data-testid="action-history__item">
            <template #icon>
              <ActionIcon :action="action" />
            </template>
            <template #headline>{{ action.human_action_name }}</template>
            <template #body>
              <div v-if="action.comment_text">
                {{ action.comment_text }}
              </div>
              <div v-if="action.zone_name">
                <span class="label">{{ $t('action.zone') }}</span>
                {{ action.zone_name }}
              </div>
              <div v-if="action.container_name">
                <span class="label">{{ $t('action.container') }}</span
                >{{ action.container_name }}
              </div>
              <div v-if="action.action_name == 'weigh_and_empty'">
                <span class="label">{{ $t('orderDetail.weight') }}</span>
                {{ order.material_weight_kg }}kg
              </div>
            </template>
            <template #image v-if="action.image">
              <img
                :src="action.image.url"
                :alt="
                  $t('actionHistory.imageAltText', {
                    actionName: action.human_name,
                  })
                "
              />
            </template>
            <template #time>{{ formattedFromDateTime(action.created_at) }}</template>
          </TimelineItem>
        </Timeline>
        <div v-else class="action-history-content">
          <p>{{ $t('actionHistory.noActionsYet') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ActionIcon from '@/components/ActionIcon/index.vue'
import TimelineItem from '@/components/Timeline/TimelineItem.vue'
import Timeline from '@/components/Timeline/index.vue'
import dateUtils from '@/components/mixins/dateUtils'
import stringUtils from '@/components/mixins/stringUtils'

import ordersApi from '@/api/orders'

export default {
  name: 'ActionHistory',
  components: { ActionIcon, Timeline, TimelineItem },
  data() {
    return {
      parentOrder: null,
    }
  },
  mixins: [dateUtils, stringUtils],
  props: {
    order: { type: Object, required: true },
  },
  computed: {
    actions() {
      return this.sortBy({
        items: this.order.actions,
        property: 'created_at',
        ascending: false,
      })
    },
    parentOrderInfo() {
      return {
        parentOriginZone: this.parentOrder?.origin_zone?.name,
        parentTargetZone: this.parentOrder?.target_zone?.name,
        parentFullContainer: this.parentOrder?.full_container?.name,
        parentEmptyContainer: this.parentOrder?.empty_container?.name,
        parentOrderType: this.parentOrder?.type,
      }
    },
  },
  async mounted() {
    if (!this.order.parent_uuid) return
    this.parentOrder = await ordersApi.get(this.order.parent_uuid)
  },
}
</script>

<style lang="scss" scoped>
.body-content {
  margin-top: 1.25rem;

  .action-history-headline {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 1rem;
      color: var(--form-control-label-color);
    }
  }

  .action-history-content {
    display: flex;
    flex-direction: column;
    max-width: 800px;
    min-width: 600px;
    margin: 0 auto 1rem;
    padding: 1.5rem;
    background-color: #efefef;
    border-radius: var(--border-radius-m);

    & > h4 {
      margin: 0 0 1rem;
      font-size: 1.2rem;
    }

    & > p {
      margin: 0 0 0.5rem;
      font-size: 1rem;
      display: flex;
      gap: 0.25rem;
    }
  }

  .label::after {
    content: ': ';
  }
}
</style>
